export const version = '0.745.1'
export const chameleonWebVersion = '8.8.3'
export const chameleonCoreVersion = '7.6.0'
